import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Table from '../../atoms/table/Table';
import DocumentTableHeader from '../../molecules/table/DocumentTableHeader';
import DocumentTableRow from '../../molecules/table/DocumentTableRow';
import NoDataTableRow from '../../molecules/table/NoDataTableRow';
const DocumentTable = ({ documents }) => {
    return (_jsxs(Table, { hasBorder: true, children: [_jsx(DocumentTableHeader, {}), documents.length > 0 &&
                documents.map(document => (_jsx(DocumentTableRow, { document: document }, document.filename))), documents.length === 0 && _jsx(NoDataTableRow, {})] }));
};
export default DocumentTable;
